import { Button, Clickable, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { openMobileAppLink } from '../core';

const AppFooter = ({ handleClose }) => {
  const { isMobile, hideBottomNav } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    location = useLocation();

  function handleGetTheApp() {
    openMobileAppLink();
  }

  if (isMobile || location.pathname.includes('admin')) return null;

  return (
    <Row
      bg="#fff"
      pos="fixed"
      zIndex="3"
      wid="100vw"
      ht="64px"
      bottom="0"
      left="0"
      style={{ boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)' }}
      centerAll
    >
      <Row between wid="936px" center>
        <Text h4>{t('getTheApp.header')}</Text>

        <Row>
          <Button
            text={t('auth.getTheApp')}
            onClick={handleGetTheApp}
            bg={theme.SECONDARY}
            small
            wid="120px"
            marg="5px"
            col="white"
          />

          <Clickable onClick={handleClose}>
            <Row ht="40px" wid="40px" hasRadius="40px" centerAll marg="0 0 0 8px">
              <Icon dimensions={14} col={theme.GREY_60} type="close" />
            </Row>
          </Clickable>
        </Row>
      </Row>
    </Row>
  );
};

export default AppFooter;
